var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisconnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4175_50166)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13048 15.1332V16.0302C9.13048 16.7496 9.489 17.3706 10.112 17.7303C10.4117 17.9033 10.7463 17.9999 11.0931 18C11.4403 18.0002 11.7748 17.9035 12.0747 17.7303L16.0634 15.4274C16.6865 15.0677 17.0449 14.4468 17.0449 13.7274V1.96305C17.0449 0.880559 16.1643 0 15.0819 0H6.29734C5.21481 0 4.33414 0.880488 4.33414 1.96305V4.44294C4.33414 4.79869 4.62299 5.08753 4.97873 5.08753C5.33459 5.08753 5.62318 4.79872 5.62318 4.44294V1.96305C5.62318 1.59135 5.92563 1.2889 6.29734 1.2889H13.9949L10.112 3.53106C9.48921 3.89071 9.13048 4.51157 9.13048 5.23076V13.8441H6.29734C5.92567 13.8441 5.62318 13.5419 5.62318 13.1701V10.9962C5.62318 10.6402 5.33476 10.3516 4.97873 10.3516C4.62285 10.3516 4.33414 10.6403 4.33414 10.9962V13.1701C4.33414 14.2527 5.21481 15.1332 6.29734 15.1332H9.13048ZM3.15803 8.21102L3.86787 8.92086C4.11955 9.17255 4.11948 9.58057 3.86787 9.83229C3.74672 9.95351 3.58345 10.0209 3.41214 10.0209C3.24065 10.0209 3.07755 9.95368 2.95623 9.83229L1.14642 8.02216C0.894808 7.77052 0.894773 7.3627 1.14642 7.11105L2.95623 5.30121C3.20795 5.04949 3.61601 5.0496 3.86783 5.30118C4.11944 5.55261 4.11938 5.96081 3.86783 6.21232L3.15803 6.92198H7.91326C8.26936 6.92198 8.55771 7.21055 8.55771 7.56661C8.55771 7.92267 8.26932 8.21106 7.91326 8.21106H3.15803V8.21102Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4175_50166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/Disconnect.f497116f.svg";
export { ForwardRef as ReactComponent };